import { Tag, TagScope } from 'dashboard/models/tag';
import Action from 'lib/interfaces/Action';

interface TagsPayload {
  tags: Tag[];
  tagScope: TagScope;
}
export type TagsActions = Action<TagsActionType.SaveTags, TagsPayload>;

export enum TagsActionType {
  SaveTags = 'tags/SAVE_TAGS',
}

export function saveTags(tags: Tag[], tagScope: TagScope) {
  return {
    payload: {
      tags,
      tagScope,
    },
    type: TagsActionType.SaveTags,
  };
}
